var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovingMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.241 10.9807C22.2448 10.9844 22.2448 10.9919 22.241 10.9957L20.831 12.3907L11.5195 3.05674L12.9296 1.65796L21.386 10.1256L22.241 10.9807Z",
    fill: "#FF56DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 6.88937C24.0005 6.91187 23.9968 6.96062 23.9518 7.00187L21.6567 9.30442L14.7266 2.35928L17.0254 0.0604782C17.1041 -0.0182735 17.1679 -0.0220235 17.2541 0.0604782L19.6429 2.44928L21.683 4.49307L23.9555 6.77312C23.9968 6.81437 24.0005 6.85937 24.0005 6.88937Z",
    fill: "#FF56DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0897 2.54291L21.9572 3.67544L20.4609 2.17915L21.5897 1.04663L23.0897 2.54291Z",
    fill: "#FF56DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4821 20.9483L11.0721 22.3433L10.097 21.3683L2.61564 13.8794L1.76063 13.0206C1.75687 13.0169 1.75687 13.0094 1.76063 13.0056L3.17065 11.6106L12.4821 20.9483Z",
    fill: "#FF56DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27394 21.6384L6.97515 23.941C6.89264 24.0197 6.83264 24.0197 6.74639 23.941L4.35759 21.5522L2.32505 19.5121C2.32505 19.5084 2.32505 19.5084 2.3213 19.5046C2.3138 19.5009 2.3138 19.5009 2.31005 19.5009L0.0450009 17.2321C0.00375008 17.1871 0 17.1383 0 17.1121C0 17.0896 0.00375008 17.0408 0.048751 16.9996L2.3438 14.697L9.27394 21.6384Z",
    fill: "#FF56DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53896 21.8222L2.41019 22.9585L0.910156 21.4585L2.04268 20.3259L3.53896 21.8222Z",
    fill: "#FF56DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0499 9.70196L14.4248 7.0769L6.99219 14.3408L9.61349 16.9696L17.0499 9.70196Z",
    fill: "#FF56DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingMore);
export default __webpack_public_path__ + "static/media/MovingMore.ad3e24711042c68f3d680e308f081765.svg";
export { ForwardRef as ReactComponent };